import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiFetch, API_BASE } from "../../utils/api";
import * as Sentry from "@sentry/react";

const BuyRedirect = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDescriptor = async () => {
      try {
        const res = await apiFetch(`/memory/${uuid}`);

        if (res?.descriptor) {
          // Set meta tags
          if (res?.title || res?.description || res?.media_url) {
            document.title = `${res.title}`;

            const setMeta = (name, content, attr = "name") => {
              let tag = document.querySelector(`meta[${attr}="${name}"]`);
              if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute(attr, name);
                document.head.appendChild(tag);
              }
              tag.setAttribute("content", content || "");
            };

            setMeta("description", res.description || "View this moment on MomentoMaster.");
            setMeta("og:title", res.title, "property");
            setMeta("og:description", res.description, "property");
            setMeta("og:image", `${API_BASE}${res.media_url}`, "property");
            setMeta("og:url", window.location.href, "property");
            setMeta("og:type", "website", "property");

            setMeta("twitter:card", "summary_large_image");
            setMeta("twitter:title", res.title);
            setMeta("twitter:description", res.description);
            setMeta("twitter:image", `${API_BASE}${res.media_url}`);
          }

          navigate(`/nft-buy/${res.descriptor}`, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch (error) {
        Sentry.captureException(error);
        console.error("❌ Redirect failed:", error);
        navigate("/", { replace: true });
      }
    };

    fetchDescriptor();
  }, [uuid, navigate]);

  return null;
};

export default BuyRedirect;